import React from 'react';

export function Facebook() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#0866FF"/>
            <g clip-path="url(#clip0_3660_21744)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C15.3137 6 18 8.68632 18 12H18.0002C18.0002 15.0677 15.6982 17.5973 12.7272 17.9561V13.8336H14.3503L14.687 12H14.686L14.6861 11.9995H12.7272V11.3515C12.7272 10.3826 13.1074 10.0099 14.0911 10.0099C14.3966 10.0099 14.6426 10.0174 14.7842 10.0322V8.37024C14.7839 8.37015 14.7836 8.37007 14.7833 8.36998V8.36974C14.515 8.2951 13.8591 8.2207 13.4789 8.2207C11.4739 8.2207 10.5497 9.16726 10.5497 11.2094V11.9995H9.3125V13.8331H9.31344V13.8336H10.5497V17.8229C10.55 17.8229 10.5503 17.823 10.5506 17.8231V17.8234C7.93728 17.1749 6 14.8138 6 12C6 8.68632 8.68632 6 12 6Z" fill="#FAFAFA"/>
            </g>
            <defs>
                <clipPath id="clip0_3660_21744">
                    <rect width="12" height="12" fill="white" transform="translate(6 6)"/>
                </clipPath>
            </defs>
        </svg>
    );
}